module.exports = __webpack_public_path__ + "img/gold4.ed591c39.png";